export default {
  setCurrentAccountVerificationState(context, payload) {
    context.commit(
      "setCurrentVerificationStep",
      payload.currentVerificationStep
    );
    context.commit(
      "setCurrentVerificationMethod",
      payload.currentVerificationMethod
    );
    context.commit("setActiveIcon", payload.activeIcon);
    context.commit(
      "setAllowedVerificationMethods",
      payload.allowedVerificationMethods
    );
    context.commit("setStartedAt", payload.startedAt);
    context.commit(
      "setBackendAuthorizationStatus",
      payload.backendAuthorizationStatus
    );
  },
  setBackendAuthorizationStatus(context, status) {
    context.commit("setBackendAuthorizationStatus", status);
  },
  resetCurrentAccountVerificationState(context, payload) {
    context.commit("resetState", null);
  },
};
